import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import axios from 'axios'; // Import Axios

const Generatedqr = ({ upiId, name }) => {
  const [qrImage, setQrImage] = useState('');

  useEffect(() => {
    // Function to generate QR code
    const generateQrCode = () => {
      // Prepare the request body
      const requestBody = {
        name: name && name ? name : "",
        vpa: upiId && upiId ? upiId : ""
      };
      // Make the POST request to the UPI QR generation API using Axios
      axios.post('https://www.upiqr.com', requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          console.log('API response:', response.data); // Log the API response data
          // Set the QR image received from the API response
          setQrImage(response.data);
        })
        .catch(error => {
          console.error('Error generating QR code:', error);
        });
    };


    generateQrCode();
  }, []);

  return (
    <>
      <div>
        {"qrImage" ? <QRCode value={`upi://pay?pa=${upiId}&pn=&cu=INR`}/> : <>Loading...</>}
      </div>
    </>
  );
};

export default Generatedqr;
